import debug from "debug";
import * as THREE from "three";
const log = debug("app:txt");

/**
 * A utility class for handling text box interactions, including raycasting and event management.
 * @category Components
 * @subcategory TextBox
 */
export default class TextBoxUtils {
  /**
   * Creates an instance of TextBoxUtils.
   * @param {Object} experience - The 3D experience containing the scene, camera, and event hub.
   */
  constructor(experience) {
    this.experience = experience;
    this.scene = experience.scene;
    this.camera = experience.camera.instance;
    this.eventHub = experience.eventHub;
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.setEventListeners();
  }

  /**
   * Sets up event listeners for global interactions, such as double-clicking.
   */
  setEventListeners() {
    // Attach a global double-click listener to handle raycasting on double-click
    this.eventHub.on("globalDoubleClick", (event) =>
      this.handleDoubleClick(event)
    );
  }

  cleanup() {
    console.log("TextBoxUtils cleanup started...");
  
    // Remove the event listener from the event hub
    if (this.eventHub) {
      this.eventHub.off("globalDoubleClick", this.handleDoubleClick);
    }
  
    // Reset properties
    this.experience = null;
    this.scene = null;
    this.camera = null;
    this.eventHub = null;
    this.raycaster = null;
    this.mouse = null;
  
    console.log("TextBoxUtils cleanup completed.");
  }

  /**
   * Handles double-click events by performing raycasting to detect text boxes.
   * @param {MouseEvent} event - The double-click event containing mouse position data.
   */
  handleDoubleClick(event) {
    log("doubleclick happened", event);

    // Calculate normalized device coordinates for the mouse position
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Perform raycasting from the camera through the mouse position
    this.raycaster.setFromCamera(this.mouse, this.camera);
    const intersects = this.raycaster.intersectObjects(
      this.scene.children,
      true
    );

    // Check for an intersected object with the required properties
    const textboxMesh = intersects.find(
      (intersect) =>
        intersect.object.name === "XMO" &&
        intersect.object.userData.mode === "textbox"
    );

    log("textboxmesh", textboxMesh);

    // Emit an event if a matching text box is found
    if (textboxMesh) {
      this.eventHub.emit("doubleClickTextBox", textboxMesh);
    }
  }
}
